module.exports = "<ng-content select=\"ic-card-menu-header\"></ng-content>\n<div class=\"ic-card__menu-body\">\n    <ng-content></ng-content>\n</div>\n<ng-content select=\"ic-card-menu-footer\"></ng-content>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/card/card-menu.component.html
// module id = ./src/app/layout/card/card-menu.component.html
// module chunks = main